import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AdminsService } from "app/modules/admins/admins.service";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
  styles: [],
})
export class UpdatePasswordComponent implements OnInit {
  @Input() content: any;
  test: Date = new Date();
  formId: FormGroup;
  submitted = false;
  errorMessage = "";
  successMessage = "";
  loader = false;
  constructor(
    public dialogRef: NgbActiveModal,
    public fb: FormBuilder,
    public service: PageService,
    public route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    console.log(this.content)
    this.formId = this.fb.group(
      {
        password: ["", [Validators.required]],
        confirmPassword: ["", [Validators.required]],
      },
      { validator: this.checkPassword("password", "confirmPassword") }
    );
  }
  get f() {
    return this.formId.controls;
  }

  checkPassword(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
        return matchingControl.status == "VALID" ? true : false;
      } else {
        matchingControl.setErrors(null);
        return matchingControl.status == "VALID" ? true : false;
      }
    };
  }
  onSubmit() {
    this.submitted = true;
    if (this.formId.invalid) {
      return;
    }
    this.loader = true;
    this.errorMessage = "";
    this.successMessage = "";
    if(this.content.adminData) {
      console.log(this.content.adminData)
      const formData = this.formId.value
      const data = {
        aggregatorAccount: {
          password: formData['password'],
        }
      }
      console.log(data)
      
      this.service
      .postMethod(`aggregator/updateAccountPassword/${this.content["adminData"]._id}`,data)
      .then((data) => {
        this.loader = false;
        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
        this.dialogRef.close({ success: true });
      });
    } else {
    this.service
      .updatePassword(this.content["data"]["record"]._id, this.formId.value)
      .then((data) => {
        this.loader = false;
        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
        this.dialogRef.close({ success: true });
      });
    console.log(this.content);
    }
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
